/* The star summary under the product name jumps to the full review section.
   Judge.me renders the badge itself, so the behaviour is attached here rather
   than inside the app block, and it is delegated because the badge arrives
   after this script runs. */
(function () {
  var BADGE = '.jdgm-widget.jdgm-preview-badge, .jdgm-preview-badge, [class*="jm-preview-badge"]';
  var TARGET = '.jdgm-review-widget, [class*="jm-review-widget"], #judgeme_product_reviews';

  function hasReviews(badge) {
    var n = badge.getAttribute('data-number-of-reviews');
    return n === null || parseInt(n, 10) > 0;
  }

  document.addEventListener('click', function (event) {
    var badge = event.target.closest && event.target.closest(BADGE);
    if (!badge || !hasReviews(badge)) return;
    var target = document.querySelector(TARGET);
    if (!target) return;
    event.preventDefault();
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });

  /* A pointer only where the jump will actually happen. */
  function mark() {
    document.querySelectorAll(BADGE).forEach(function (badge) {
      if (!document.querySelector(TARGET) || !hasReviews(badge)) return;
      badge.style.cursor = 'pointer';
      if (!badge.hasAttribute('role')) {
        badge.setAttribute('role', 'link');
        badge.setAttribute('tabindex', '0');
      }
    });
  }

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Enter' && event.key !== ' ') return;
    var badge = document.activeElement && document.activeElement.closest(BADGE);
    if (badge) badge.click();
  });

  document.addEventListener('DOMContentLoaded', mark);
  /* Judge.me paints late and re-paints on variant change. */
  new MutationObserver(mark).observe(document.documentElement, { childList: true, subtree: true });
})();
